export const environment = {
  appVersion: '',
  appBuildNumber: '',
  production: false,
  baseApiUrl: '',
  froalaKey: '[loaded via api]',
  scaytCustomerId: '[loaded via api]',
  azureMapsSubscriptionKey: '[loaded via api]',
  pspdfkitUrl: '[loaded via api]',
  pspdfkitLicenseKey: '[loaded via api]',
  releaseNotesUrl: '[loaded via api]',
  appStoreUrl: '[loaded via api]',
  playStoreUrl: '[loaded via api]',
  androidPackageName: '[loaded via api]',
  isDemoTenant: false, //loaded via api
  isAiEnabled: false, //loaded via api
  environmentName: 'Dev', //loaded via api
  aiChatSoftTimeoutSeconds: 30, //loaded via api
  aiChatTimeoutExtensionSeconds: 30, //loaded via api
};
